<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/r9tdn5/tc-custom/9781550925791.jpg?1729082544955" alt="This image is the cover for the book Real Goods Solar Living Sourcebook, Mother Earth News Books for Wiser Living"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Real Goods Solar Living Sourcebook, Mother Earth News Books for Wiser Living
      </h1>
      <p class="bookDescription body article font2">
        <p>What book would you want if you were stranded on a desert island? Widely regarded as the 'bible' of off-grid living, The <i> Solar Living Sourcebook </i> might be your best choice. With over 600,000 copies in print worldwide, it is the most comprehensive resource available for anyone interested in lessening their environmental footprint and increasing their energy independence.</p><p>The <i> Solar Living Sourcebook-14th Edition </i> is the ultimate guide to renewable energy, sustainable living, natural and green building, off-grid living and alternative transportation, written by experts with decades of experience and a passion for sharing their knowledge. This fully revised and updated edition includes brand new sections on permaculture and urban homesteading, and completely rewritten chapters on solar technology, sustainable transportation and relocalization. It also boasts greatly expanded material on:</p>Natural BuildingPermaculture and biodynamicsElectric and biofuel-powered vehiclesPassive solarSolar water heatingGrid-tie photovoltaic systems<p>-- plus maps, wiring diagrams, formulae, charts, electrical code, solar sizing worksheets and much more.</p><p>Whether you're a layperson or a professional, novice or longtime aficionado, the <i> Sourcebook </i> puts the latest research and information at your fingertips-everything you need to know to make sustainable living a reality.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Schaeffer, Bill McKibben
      </h2>
      
      <p class="authorDescription body article"><P><B> John Schaeffer </B> is the president and founder of Real Goods - the foremost global source for tools and information on renewable energy, energy-efficient and sustainable living. He sold the very first photovoltaic (solar module) to the North American public in 1978 and over the years, through Real Goods, he has provided over 100 MW of solar power and has helped solarize over 15,000 homes. John is also the founder of the Solar Living Institute, based at the 12-acre solar-powered Solar Living Center in Hopland, California. The SLI hosts over 200,000 visitors a year, provides hands-on education into all aspects of renewable energy and sustainable living, and produces the SolFest renewable energy fair.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Society Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67e59b97